<div class="chat-width-a">
    <h2 mat-dialog-title class="md-title chat-cont-a">
        <img src='../../assets/images/logoclaro2.png' style='width:32px;height:32px; vertical-align: middle;'>
        <label class='labTitle chatTitle-b'>T&eacute;rminos y Condiciones</label>
    </h2>
    <mat-dialog-content class="chat-cont-a">
        <div class="chatJAC">
            <div class="popupbg">
                <div class="popupcont f-reg f-black roboto-r">
                    <div class="termr-t">
                        <div class="basicrow">
                            <div class="padTerms">
                                <div class="">
                                    <div class="padtop">
                                        • Al aceptar la compra del regalo, se le facturará al momento el
                                        precio del paquete adquirido según se indica y podrá verlo en su
                                        próxima factura; independientemente de que el receptor acepte o no
                                        acepte su regalo. No se aceptarán reclamaciones por regalos no
                                        aceptados.
                                    </div>
                                    <div class="padtop">
                                        • El número de teléfono de la persona que recibirá el regalo deberá
                                        ser un número de telefonía móvil pospagado de Claro Puerto Rico
                                        exclusivamente.
                                    </div>
                                    <div class="padtop">
                                        • No aplica a teléfonos fijos de Claro, clientes con servicio
                                        prepago de Claro, clientes de Claro con planes de servicio sin datos
                                        o celulares de otras compañías de teléfonos u otros países.
                                    </div>
                                    <div class="padtop">
                                        • El recipiente del regalo recibirá un mensaje de texto y una
                                        notificación en su cuenta de MiClaro y tendrá 30 días a partir de la
                                        fecha en que usted compra el regalo.
                                    </div>
                                    <div class="padtop">
                                        • Luego de transcurridos los 30 días, el link del mensaje de texto
                                        estará inválido y no podrá accederlo; tampoco podrá ver la
                                        notificación en su cuenta MiClaro.
                                    </div>
                                    <div class="padtop">
                                        • Una vez el recipiente lo haya aceptado, el regalo estará activo en
                                        su cuenta 30 días calendario. Culmina una vez lo consuma totalmente
                                        o se cumpla el termino de 30 días, lo que ocurra primero.
                                    </div>
                                    <div class="padtop">
                                        • El regalo de data podrá ser utilizado luego de que el cliente que
                                        recibe consuma su paquete de datos principal.
                                    </div>
                                    <div class="padtop">
                                        • Si el cliente ha bloqueado voluntariamente el servicio de datos,
                                        el regalo será rechazado.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <div class="logline full top-r1"></div>
    <div class="basicrow text-center m-top">
        <a class="btns def-i red pull-right vcenter" (click)="this.close();">
            <span class="tabcell">
                Cerrar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
        </a>
    </div>
</div>